"use strict";
exports.__esModule = true;
/**
 * Verify input string as username.
 *
 * Username rule:
 *     case insensitive,
 *     length 1 to 20 (include),
 *     only allow letters (a-z), numbers (0-9) and period (.)
 *
 * @param username {string} A string as username.
 * @returns {boolean}
 */
function verifyUsername(username) {
    if (typeof username !== 'string' || !username) {
        // Type wrong or empty.
        return false;
    }
    if (username.length < 1 || username.length > 20) {
        // Input too long.
        return false;
    }
    return /^[A-Za-z0-9.]+$/.test(username);
}
exports.verifyUsername = verifyUsername;
/**
 * Check if user exists in current user list.
 *
 * @param userlist {Array<{}>} List of users, should have username
 *     property.
 * @param userObj {{}} Input user.
 * @returns {boolean} True if user exists.
 */
function usernameExists(userlist, userObj) {
    if (!userlist || !userlist.length) {
        return false;
    }
    var duplicateUser = userlist.find(function (u) { return u.username === userObj.username && u._id !== userObj._id; });
    return (duplicateUser || false) && true;
}
exports.usernameExists = usernameExists;
/**
 * The email test we only use very very very very simple thing.
 *
 * @param input {string} String as email.
 * @returns {boolean} True if it passes this dummy test.
 */
function verifyEmail(input) {
    if (typeof input !== 'string' || !input) {
        return false;
    }
    return /^\S+@\S+$/.test(input);
}
exports.verifyEmail = verifyEmail;
/**
 * Check if email exists in current user list.
 *
 * @param userlist {Array<{}>} List of users, should have email
 *     address related to user.
 * @param input {{}} Input user.
 * @returns {boolean} True if email_id exists.
 */
function emailExists(userlist, input) {
    if (!userlist || !userlist.length) {
        return false;
    }
    var duplicateUser = userlist.filter(function (u) { return u.email; }).find(function (u) { return u.email.toLowerCase() === input.email.toLowerCase() && u._id !== input._id; });
    return (duplicateUser || false) && true;
}
exports.emailExists = emailExists;
//# sourceMappingURL=user-verification.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/address-book2/user-verification.js